import React from 'react';

import {
  Controller,
  ControllerRenderProps,
  FieldError,
  UseControllerOptions,
  ValidationRule,
} from 'react-hook-form';

import MuiTextField, { TextFieldProps } from '@material-ui/core/TextField';

import { UiPhoneTextFieldWithReference } from '../../ui/ui-phone-text-field';

type InputProps = {
  maxLength?: ValidationRule<string | number>;
  error?: FieldError;
  textFieldVariant?: 'phone' | 'text';
};

// We omit defaultValue because value on the textfield is always set when using
// react-hook-form through control
type Props = InputProps &
  Omit<
    UseControllerOptions & Omit<TextFieldProps, keyof InputProps | 'onChange' | 'onError'>,
    'defaultValue'
  >;

export const FormTextField = ({
  name,
  control,
  error,
  required,
  maxLength,
  rules,
  textFieldVariant,
  ...otherProps
}: Props) => {
  const controllerProps = {
    control,
    name,
    rules: {
      ...rules,
      required: required || rules?.required ? 'Required' : false,
      maxLength,
    },
  };

  const fieldProps = {
    error: Boolean(error),
    helperText: error?.message,
    required: Boolean(required || rules?.required),
  };

  const Component = textFieldVariant === 'phone' ? UiPhoneTextFieldWithReference : MuiTextField;

  return (
    // we currently use v6 and the props interface of the render function is different in v7 - docs here https://react-hook-form.com/v6/api#Controller
    <Controller
      render={(props: ControllerRenderProps) => (
        <Component {...props} {...fieldProps} fullWidth {...otherProps} />
      )}
      {...controllerProps}
    />
  );
};
